export default "__VITE_ASSET__BL$rrx$L__"